import ParkerLogo from '@assets/images/ParkerLogo.jpg'
import { TABS } from '@common/constants/global.constants'
import { Role } from '@common/enums/request.enums'
import { Tab as TabType } from '@common/types/global.types'
import LanguageSelectInput from '@components/inputs/LanguageSelectInput'
import { Route } from '@config/routes/routes.enums'
import { GREY_COLORS } from '@config/theme/colors'
import { FontWeight } from '@config/theme/sizes'
import {
	Stack,
	styled,
	Typography
} from '@mui/material'
import { useAuth } from '@services/contexts/AuthContext'
import { FormattedMessage } from 'react-intl'
import {
	useLocation,
	useNavigate
} from 'react-router-dom'

/**
 * Header
 * @constructor
 */
const Header = () => {
	const { user } = useAuth()
	const location = useLocation()
	const navigate = useNavigate()

	const renderTab = ({ route, isDisabled }: TabType) => (
		<Tab
			key={route}
			onClick={() => !isDisabled && navigate(`/${route}`)}
			style={{
				cursor: isDisabled ? 'default' : 'pointer',
				opacity: isDisabled ? 0.5 : 1
			}}
		>
			<TabValue isSelected={location.pathname.includes(route)} fontWeight={FontWeight.MEDIUM}>
				<FormattedMessage id={`global.tabs.${route}`} />
			</TabValue>
		</Tab>
	)

	return (
		<Container>
			<LeftPart>
				<Logo
					alt="Parker Logo"
					onClick={() => navigate(`/${Route.HOME}`)}
					src={ParkerLogo}
				/>
				<Tabs>
					{
						TABS
							.filter((tab: TabType) => !tab.isAdmin || user.role === Role.ADMIN)
							.map(renderTab)
					}
				</Tabs>
			</LeftPart>
			<Actions>
				<LanguageSelectInput />
				<User onClick={() => navigate(`/${Route.TRAINEES}/${user.id}`)}>
					<Typography fontWeight={FontWeight.MEDIUM}>
						{user.name}
					</Typography>
				</User>
			</Actions>
		</Container>
	)
}

const Container = styled(Stack)({
	alignItems: 'center',
	flexDirection: 'row',
	justifyContent: 'space-between',
	padding: '20px'
})

const LeftPart = styled(Stack)({
	alignItems: 'center',
	columnGap: '20px',
	flexDirection: 'row'
})

const Logo = styled('img')({
	cursor: 'pointer',
	height: '40px',
	objectFit: 'contain'
})

const Tabs = styled(Stack)({
	columnGap: '8px',
	flexDirection: 'row'
})

const Tab = styled(Stack)({
	backgroundColor: GREY_COLORS[100],
	borderRadius: '8px',
	padding: '12px 16px'
})

const TabValue = styled(
	Typography,
	{ shouldForwardProp: (prop) => prop !== 'isSelected' }
)<{ isSelected: boolean }>(({ isSelected }) => ({
	color: isSelected ? 'auto' : GREY_COLORS[400]
}))

const Actions = styled(Stack)({
	alignItems: 'center',
	columnGap: '16px',
	flexDirection: 'row',
	height: '100%'
})

const User = styled(Stack)({
	cursor: 'pointer'
})

export default Header
